import { c as _c } from "react/compiler-runtime";
import { Separator } from '@achra/ui/separator';
import { Fragment } from 'react';
import { SERVICE_PURCHASE_STEPS_ENTRIES } from '@/modules/service-purchase/lib/constants';
import type { ServicePurchaseStep } from '@/modules/service-purchase/types';
import { StepTriggerSkeleton } from './step-trigger-skeleton';
interface StepsTriggerListSkeletonProps {
  activeStep?: ServicePurchaseStep;
}
function StepsTriggerListSkeleton(t0) {
  const $ = _c(5);
  const {
    activeStep
  } = t0;
  let t1;
  if ($[0] !== activeStep) {
    t1 = activeStep !== undefined ? SERVICE_PURCHASE_STEPS_ENTRIES.findIndex(entry => entry.value === activeStep) : 0;
    $[0] = activeStep;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeIndex = t1;
  const resolvedActiveIndex = activeIndex >= 0 ? activeIndex : 0;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Array.from({
      length: 5
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== resolvedActiveIndex) {
    t3 = <div className="flex h-fit w-full items-center justify-center bg-transparent p-0 md:justify-between">{t2.map((_, index) => <Fragment key={index}><StepTriggerSkeleton active={index === resolvedActiveIndex} />{index < 4 && <Separator orientation="horizontal" className="bg-border h-0.5! max-w-8! flex-1" />}</Fragment>)}</div>;
    $[3] = resolvedActiveIndex;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export { StepsTriggerListSkeleton };